<template>
  <section class="mog-group">
    <h4 class="mog-title">{{ title }}</h4>
    <materials-order-item-row
      v-for="item in group.items"
      :key="item.material_id"
      :item="item"
      :presets="item.presets"
      :max-quantity="maxQuantity"
      :quick-buttons="quickButtons"
      :quantity="selection[item.material_id] || null"
      @change="changeQuantity(item.material_id, $event)"
    />
  </section>
</template>

<script>
import MaterialsOrderItemRow from './MaterialsOrderItemRow.vue';
import { groupLabel } from './materialsOrderSelection';

export default {
  name: 'MaterialsOrderGroup',
  components: { MaterialsOrderItemRow },
  props: {
    group: { type: Object, required: true },
    selection: { type: Object, default: () => ({}) },
    maxQuantity: { type: Number, required: true },
    quickButtons: { type: Boolean, default: true },
  },
  computed: {
    title() {
      return groupLabel(this.group.key);
    },
  },
  methods: {
    changeQuantity(materialId, quantity) {
      this.$emit('change', { groupKey: this.group.key, materialId, quantity });
    },
  },
};
</script>

<style scoped>
.mog-title {
  margin: 12px 0 0;
  font-size: 12px;
  font-weight: 700;
  color: #01662E;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
</style>
